// src/pages/Applications.js
import React, { useEffect, useState } from "react";
import { apiFetch } from "../api";

export default function Applications(){
  const [apps, setApps] = useState([]);
  useEffect(()=> {
    apiFetch("workwithus").then(d => setApps(d.applications || []));
  },[]);
  return (
    <div className="page">
      <h2>Applications</h2>
      <table className="table">
        <thead><tr><th>ID</th><th>Name</th><th>Email</th><th>Job</th><th>Date</th></tr></thead>
        <tbody>
          {apps.map(a => (
            <tr key={a.id}><td>{a.id}</td><td>{a.name}</td><td>{a.email}</td><td>{a.job_title}</td><td>{a.date}</td></tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
